// import PurposeEdit from "./assessmentEdit/PurposeEdit";
import { useEffect, useState } from "react";
import WitnessEdit from "./assessmentEdit/WitnessEdit";
import { FaEdit, FaNewspaper } from "react-icons/fa";
import { getSearchInfo } from '../../../shared/utils/storage';


const PurposeInfo = () => {
  const [application, setApplication] = useState()

  useEffect(() => {
    const searchedData = getSearchInfo()
    if (searchedData) {
      setApplication(searchedData?.data)
    }
  }, [])
  //const data = useLocation().state
  const travelInfo = application?.TravelInfo[0]
  const styles = {
    h4: {
      color: '#850505',
      textTransform: 'uppercase',
    }
  };

  return (
    <>
      <table id="viewTable">
        <tr>
          <th colspan="2">
            <h4>
              <b>Travel Information</b>
            </h4>
          </th>
          <th style={{ textAlign: "right" }}>
            <b>
              <FaNewspaper style={{ fontSize: "23px" }} />
            </b>
          </th>
        </tr>
        <tr>
          <td>
            Dhumuni la Safari: <br />
            <h4 style={styles.h4}>
              {travelInfo?.Purpose}
            </h4>
          </td>
          <td>
            Nchi anayokwenda: <br />
            <h4 style={styles.h4}>{travelInfo?.Country}</h4>
          </td>
          <td>
            Kazi : <br />
            <h4 style={styles.h4}>{travelInfo?.Occupation}</h4>
          </td>
        </tr>
      </table>

      <br />


    </>
  );
}

export default PurposeInfo;
